/** Toast switches, as named in `index.css` (each one resolves an operator's
 *  `--co-…Notification-visibility` knob, `shown` when unset). */
export type NotificationSwitch =
  | '--ui-notification-buyback'
  | '--ui-notification-vaulted'
  | '--ui-notification-exit-vaulted';

const HIDDEN = 'hidden';

/** False when the operator turned this toast off in the Design Constructor. */
export function isNotificationShown(name: NotificationSwitch): boolean {
  if (typeof document === 'undefined') return true;
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim() !== HIDDEN;
}
